import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Portfolio", path: "/portfolio" },
  { label: "Academy", path: "/academy" },
  { label: "AI Readiness", path: "/ai-readiness" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white border-b border-gray-100"
          : "bg-white/80 backdrop-blur-sm border-b border-slate-100"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/cb426ff5-dcc6-4b58-a46b-a15590b7905f/4e4a0367-5e2c-45d8-91e9-fda23ca7a1cf_cpi_technologies_logo.svg?v=e4f1fbaacb042912542760333caa4b48"
            alt="CPI Technologies"
            className="h-12 w-auto max-w-[160px] object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? "text-slate-900 font-semibold"
                  : "text-gray-600 hover:text-slate-900"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="text-sm font-bold px-5 py-2 rounded-full whitespace-nowrap cursor-pointer transition-all bg-black text-[#C8F135] hover:bg-[#C8F135] hover:text-black"
          >
            Let&apos;s Talk
          </Link>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer text-gray-900"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium py-2 cursor-pointer ${
                location.pathname === link.path ? "text-slate-900 font-semibold" : "text-gray-600"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-2 text-center text-sm font-bold px-5 py-2.5 rounded-full bg-black text-[#C8F135] whitespace-nowrap cursor-pointer"
          >
            Let&apos;s Talk
          </Link>
        </div>
      )}
    </header>
  );
}
